import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpRequestService } from './http-request.service';
import jwt_decode from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  userData: any = [];
  decodedToken: any;
  accessToken: string;

  constructor(private http: HttpRequestService) { }

  userInfo() {

    this.accessToken = localStorage.getItem('token')

    let data=JSON.stringify(jwt_decode(this.accessToken))

    this.decodedToken=JSON.parse(data)
 
    return this.decodedToken
  }



}